export const openWhatsApp = (name, state) => {
    const phoneDigits = "5531984317695";
    // const phoneDigits = "5531973026306";
    const messageDescription = buildDescription(state)
    let message = `*Busca de Peça*\n\nOlá, *Deixa Que Eu Procuro*!\n\nAqui é *${name}* e estou buscando:\n*${messageDescription}*`;

    const text = encodeURIComponent(message);

    // wa.me funciona bem em desktop e mobile
    const url = `https://wa.me/${phoneDigits}?text=${text}`;

    window.open(url, "_blank", "noopener,noreferrer");
};

export const buildDescription = (state) => {
    const {request, optional} = state

    let description = request.description

    if (optional.model !== "") {
        description += ` ${optional.model}`
    }

    if (optional.fabYear !== 0) {
        description += ` ${optional.fabYear}`
    }

    if (optional.modelYear !== 0) {
        description += `/${optional.modelYear}`
    }

    return description
}